/**
 * Brazilian Portuguese (pt-BR) mappings for Volleyball Dashboard
 * Complete translations for volleyball components
 */

export const volleyballDashPtBR = {
  // Header
  "Sports Hub • Volleyball": "Centro Esportivo • Vôlei",
  "Volleyball Dashboard": "Terminal de Vôlei",
  "Track live games, standings, and teams from volleyball leagues worldwide": "Acompanhe jogos ao vivo, classificações e times de ligas de vôlei do mundo todo",
  
  // Beta Notice
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  "v3-Beta: Not all features available yet": "v3-Beta: Nem todos os recursos disponíveis ainda",
  
  // Tabs
  "Games": "Jogos",
  "Standings": "Classificação",
  "Teams": "Times",
  
  // Filters
  "Date": "Data",
  "Country": "País",
  "League": "Liga",
  "Season": "Temporada",
  "Refresh": "Atualizar",
  "All Countries": "Todos os Países",
  "All Leagues": "Todas as Ligas",
  "All Seasons": "Todas as Temporadas",
  "Select League": "Selecionar Liga",
  "Select Season": "Selecionar Temporada",
  
  // Countries
  "USA": "EUA",
  "Brazil": "Brasil",
  "Italy": "Itália",
  "Russia": "Rússia",
  "Poland": "Polônia",
  "Japan": "Japão",
  
  // Game Status
  "Not Started": "Não Iniciado",
  "Live": "Ao Vivo",
  "Finished": "Finalizado",
  "Final": "Final",
  "Postponed": "Adiado",
  "Cancelled": "Cancelado",
  "VS": "VS",
  
  // Games View
  "Match Details": "Detalhes da Partida",
  "Select a game to view details": "Selecione um jogo para ver detalhes",
  "No games found": "Nenhum jogo encontrado",
  "Try selecting a different date or league": "Tente selecionar uma data ou liga diferente",
  "Loading games...": "Carregando jogos...",
  "FINAL SCORE": "PLACAR FINAL",
  "Home": "Casa",
  "Away": "Visitante",
  
  // Standings View
  "League Standings": "Classificação da Liga",
  "Select a league and season": "Selecione uma liga e temporada",
  "Loading standings...": "Carregando classificação...",
  "POS": "POS",
  "TEAM": "TIME",
  "GP": "J",
  "W": "V",
  "L": "D",
  "SETS": "SETS",
  "PTS": "PTS",
  
  // Teams View
  "No teams found": "Nenhum time encontrado",
  "Try adjusting your filters": "Tente ajustar seus filtros",
  "Loading teams...": "Carregando times...",
  "Team ID": "ID do Time",
  "Page": "Página",
  "of": "de",
  
  // Pagination
  "Page {0} of {1}": "Página {0} de {1}",
  
  // Loading States
  "Loading...": "Carregando...",
  "Loading data...": "Carregando dados...",
  "Refreshing...": "Atualizando...",
  
  // Error Messages
  "Failed to load games": "Falha ao carregar jogos",
  "Failed to load standings": "Falha ao carregar classificação",
  "Failed to load teams": "Falha ao carregar times",
  "An error occurred": "Ocorreu um erro",
  "Please try again": "Por favor, tente novamente",
  
  // Empty States
  "No data available": "Nenhum dado disponível",
  "No matches scheduled": "Nenhuma partida agendada",
  "No standings available": "Nenhuma classificação disponível",
  
  // Actions
  "View": "Ver",
  "Close": "Fechar",
  "Filter": "Filtrar",
  "Clear": "Limpar",
  "Apply": "Aplicar",
  "Cancel": "Cancelar",
  "Reset": "Redefinir",
  
  // Time
  "Today": "Hoje",
  "Yesterday": "Ontem",
  "Tomorrow": "Amanhã",
  "Now": "Agora",
  
  // Season Format
  "{0} Season": "Temporada {0}",
  
  // Additional Terms
  "Round": "Rodada",
  "Set": "Set",
  "Point": "Ponto",
  "Service": "Saque",
  "Block": "Bloqueio",
  "Attack": "Ataque",
  "Defense": "Defesa",
  "Timeout": "Tempo",
  
  // League Names (if needed)
  "Championship": "Campeonato",
  "Cup": "Copa",
  "Tournament": "Torneio",
  "World Championship": "Campeonato Mundial",
  "Olympic Games": "Jogos Olímpicos",
  "Nations League": "Liga das Nações",
  
  // Match Information
  "Match Information": "Informações da Partida",
  "Venue": "Local",
  "Referee": "Árbitro",
  "Duration": "Duração",
  "Attendance": "Público",
  
  // Statistics
  "Statistics": "Estatísticas",
  "Aces": "Aces",
  "Blocks": "Bloqueios",
  "Attacks": "Ataques",
  "Errors": "Erros",
  "Points": "Pontos",
  
  // Quick Actions
  "Quick Actions": "Ações Rápidas",
  "Predict Winner": "Prever Vencedor",
  "View Stats": "Ver Estatísticas",
  "Share": "Compartilhar",
  
  // Tooltips
  "Click to select": "Clique para selecionar",
  "Click for details": "Clique para detalhes",
  "Refresh data": "Atualizar dados",
  "Go to previous page": "Ir para página anterior",
  "Go to next page": "Ir para próxima página",
  
  // Mobile specific (if needed)
  "Pull to refresh": "Puxe para atualizar",
  "Swipe for more": "Deslize para mais",
  "Tap to expand": "Toque para expandir"
};